import { render, staticRenderFns } from "./Batchjobs.vue?vue&type=template&id=31a4e406"
import script from "./Batchjobs.vue?vue&type=script&lang=js"
export * from "./Batchjobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports